<template>
  <!-- 敏感词拦截记录 -->
  <div class="Sensitive-keywords-log-list">
    <div class="container">
      <!-- 搜索条件 -->
      <div class="Sensitive-keywords-log-list-search">
        <el-form
          ref="sensitiveKeywordsLogFormRef"
          :inline="true"
          :model="sensitiveKeywordsLogForm"
          class="demo-form-inline"
        >
          <el-form-item label="拦截时间">
            <el-date-picker
              v-model="sensitiveKeywordsLogForm.date"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              unlink-panels
              range-separator="——"
              end-placeholder="结束日期"
              start-placeholder="开始日期"
              size="small"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="敏感词">
            <el-input
              v-model="sensitiveKeywordsLogForm.keywords_name"
              clearable
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="searchBtn">
              查 询<i class="el-icon-search el-icon--right" />
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div class="Sensitive-keywords-log-list-table">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :data="sensitiveKeywordsLogData"
          style="width: 100%"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            :fixed="item.fixed"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'user_name'">
                {{ scope.row.from | fromText }}
                <span v-if="scope.row[item.prop]"
                  >（{{ scope.row[item.prop] }}）</span
                >
              </div>

              <div v-else-if="item.prop == 'create_time'">
                {{ scope.row.create_time | dateFormat }}
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import template from "@/api/template";
export default {
  components: {
    Pagination,
  },

  data() {
    return {
      sensitiveKeywordsLogForm: {
        date: "",
        keywords_name: "",
      },
      total: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "含敏感词内容",
          prop: "content",
          width: "auto",
          fixed: "left",
        },
        {
          label: "匹配到的敏感词",
          prop: "keywords_name",
          width: "auto",
          fixed: false,
        },
        {
          label: "敏感类型",
          prop: "type_name",
          width: "auto",
          fixed: false,
        },
        {
          label: "敏感词使用人",
          prop: "user_name",
          width: "auto",
          fixed: false,
        },
        {
          label: "敏感词拦截场境",
          prop: "rule_limit_str",
          width: "auto",
          fixed: false,
        },
        {
          label: "拦截时间",
          prop: "create_time",
          width: "auto",
          fixed: false,
        },
      ],
      sensitiveKeywordsLogData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    fromText(val) {
      switch (val) {
        case 1:
          return "医生";
        case 2:
          return "患者";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const date = [];
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 2 * 30 * 24 * 60 * 60 * 1000);
      date.push(dayjs(start).format("YYYY-MM-DD"));
      date.push(dayjs(end).format("YYYY-MM-DD"));
      this.sensitiveKeywordsLogForm.date = date;
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      let params = Object.assign(
        {},
        this.pagination,
        this.sensitiveKeywordsLogForm
      );
      params = _.omit(params, ["date"]);
      let times = this.sensitiveKeywordsLogForm.date;
      params["start_time"] = times ? times[0] : "";
      params["end_time"] = times ? times[1] : "";
      template.getSensitiveKeywordsCheckLogList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          this.sensitiveKeywordsLogData = data.list;
          this.tableLoading = false;
        }
      });
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.Sensitive-keywords-log-list {
  .Sensitive-keywords-log-list-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .Sensitive-keywords-log-list-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
<style lang="scss">
.custom-keywords-drawer {
  .el-drawer__header {
    text-align: left;
    font-weight: bold;
    color: #000;
    font-size: 18px;
    padding: 20px 10px;
    border-bottom: 1px solid #dcdfe6;
  }
  .add-keywords {
    padding: 0 10px;
    .keywords-name {
      .el-form-item__content {
        height: auto;
      }
    }
  }
}
</style>
